import sellerReducer from '@/state/modules/inquiry/reducers';

export { default as actions } from '@/state/modules/inquiry/actions';
export { default as sagas } from '@/state/modules/inquiry/sagas';
export { default as operations } from '@/state/modules/inquiry/operations';
export { default as selectors } from '@/state/modules/inquiry/selectors';

export default sellerReducer;
